//@flow
import * as React from 'react';
import EditableChipsListField from 'common/components/common/EditableChipsListField';
import { memoized } from 'common/utils/Memoizer';

class RiderEditableChips extends React.Component {
    @memoized()
    getRiderOptions(riders) {
        return riders
            .map(rider => {
                const { name, userId } = rider;
                return { label: name, value: userId };
            })
            .toJS();
    }

    getSelectedRiders = riders => {
        return riders.map(rider => rider.userId).toJS();
    };

    getRiderOptionMeta(option) {
        return option.value;
    }

    getValueLabel = value => {
        const { availableRiders, showUserId } = this.props;
        const matchedRiderObj = this.getRiderOptions(availableRiders).find(
            option => option.value === value
        );

        if (!matchedRiderObj) {
            return value;
        }
        if (showUserId) {
            return `${matchedRiderObj.label} (${matchedRiderObj.value})`;
        }
        return `${matchedRiderObj.label}`;
    };

    getOptionLabel = rider => {
        return this.getValueLabel(rider.value);
    };

    chipBackgroundHandler = value => {
        const { availableRiders } = this.props;
        const riderFound = !!this.getRiderOptions(availableRiders).find(
            option => option.value === value
        );

        if (!riderFound) {
            return 'salmon';
        }
        return null;
    };

    render() {
        const {
            isEditable,
            emptyStateText,
            disableMapEvents,
            enableMapEvents,
            riders,
            onRidersChange,
            availableRiders,
            theme
        } = this.props;
        const options = this.getRiderOptions(availableRiders);
        const value = this.getSelectedRiders(riders);
        return (
            <EditableChipsListField
                getValueLabel={this.getValueLabel}
                saveOnEnter={false}
                noHover
                creatable={false}
                emptyStateText={emptyStateText}
                disabled={!isEditable}
                isFocused={isEditable}
                defaultFocused={false}
                onFocus={disableMapEvents}
                onBlur={enableMapEvents}
                onMouseEnter={disableMapEvents}
                onMouseLeave={enableMapEvents}
                theme={theme}
                customFieldClass={riders.size === 0 ? theme.isEmpty : null}
                isEditingEnabled={isEditable}
                value={value}
                onSave={onRidersChange}
                options={options}
                getOptionMeta={this.getRiderOptionMeta}
                getOptionLabel={this.getOptionLabel}
                chipBackground={this.chipBackgroundHandler}
                doubleLine
            />
        );
    }
}
export { RiderEditableChips };
export default RiderEditableChips;
